// extracted by mini-css-extract-plugin
module.exports = {"czsvxh4":"czsvxh4","b15p73xd":"b15p73xd","mjw5hgx":"mjw5hgx","t2ipu9v":"t2ipu9v","a13tcixg":"a13tcixg","i1chj520":"i1chj520"};